import script from "./SameColorBallsSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./SameColorBallsSelector.vue?vue&type=script&setup=true&lang=ts"

import "./SameColorBallsSelector.vue?vue&type=style&index=0&id=2dfa2f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dfa2f74"]])

export default __exports__